import { render } from "./ReviewCommentEditor.vue?vue&type=template&id=3430e8be&ts=true"
import script from "./ReviewCommentEditor.ts?vue&type=script&lang=ts&external"
export * from "./ReviewCommentEditor.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__